import {
  IN_OPERATORS,
  getLimitRelatedErrors,
  isThereDeprecatedOperator,
} from 'src/utils/audience-list';
import {getAudienceRulesSignature} from 'src/utils/audience-revamp';

import type {AudienceListState} from 'src/reducers/audience-list';
import type {State} from 'src/reducers';
import {createSelector} from 'reselect';
/*
 * Base Selectors
 */
export const selectList = (state: State): AudienceListState =>
  state.audienceList;

export const selectTotalInNotInCount = (state: State): number => {
  const {inclusions, exclusions}: AudienceListState = state.audienceList;
  let totalInNotInRuleCount = 0;
  const inclusionsAndExclusions = new Map([...inclusions, ...exclusions]);
  inclusionsAndExclusions.forEach((ruleBlockArr, ruleBlockKey) => {
    ruleBlockArr.forEach((ruleItem) => {
      // @ts-expect-error - TS2339 - Property 'operator' does not exist on type 'AudienceRule'. | TS2339 - Property 'operator' does not exist on type 'AudienceRule'.
      if (ruleItem.operator && IN_OPERATORS.includes(ruleItem.operator)) {
        // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'AudienceRule'.
        const ruleValueCount = Array.isArray(ruleItem.value)
          ? // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'AudienceRule'.
            ruleItem.value.length
          : 0;
        totalInNotInRuleCount += ruleValueCount;
      }
    });
  });
  return totalInNotInRuleCount;
};

export const selectLimitRelatedErrors: (state: State) => Array<string> =
  createSelector(
    selectList,
    selectTotalInNotInCount,
    (audienceList, totalInNotInCount) => {
      const {inclusions, exclusions}: AudienceListState = audienceList;
      const allBlocks = new Map([...inclusions, ...exclusions]);
      const ruleItemWithErrors = getLimitRelatedErrors(
        allBlocks,
        totalInNotInCount,
      );
      return ruleItemWithErrors;
    },
  );

export const selectIsDepricatedOperatorPresent: (state: State) => boolean =
  createSelector(selectList, (audienceList) => {
    const {inclusions, exclusions}: AudienceListState = audienceList;
    const allBlocks = new Map([...inclusions, ...exclusions]);
    const isDeprecatedOperatorPresent = isThereDeprecatedOperator(allBlocks);
    return isDeprecatedOperatorPresent;
  });

// True when rules differ from the saved baseline or none exists; keeps Save disabled on identical AI regen (PF-8675).
export const selectIsAudienceListDirty: (state: State) => boolean =
  createSelector(selectList, ({all, inclusions, exclusions, savedSnapshot}) => {
    if (savedSnapshot == null) {
      return true;
    }
    return (
      getAudienceRulesSignature({
        all: all ?? false,
        inclusions,
        exclusions,
      }) !== savedSnapshot
    );
  });
